module.exports = __webpack_public_path__ + "static/media/brahem6.f0dd65c7.webp";